module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm2 25a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm0-7.344V19a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3c0-1.106.25-2 1.5-2H17a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1c0 .278-.188 1-1 1h-2c-.75 0-1.008-.45-.918-.996A6.012 6.012 0 0 1 16 6c3.308 0 6 2.692 6 6a6.007 6.007 0 0 1-4 5.656z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/question-2.js
// module id = 1361
// module chunks = 14